/**
 * Returns value within `mod` and allows negative numbers
 *
 * Examples:
 *
 * universalModulo(17, 16) // 1
 *
 * universalModulo(-1, 16) // 15
 */
export function universalModulo(value: number, mod: number): number {
  return ((value % mod) + mod) % mod
}
